<template>
  <fh-container>
    <v-card-title
      >Configuración de cultivos<v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-col class="py-0">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Nuevo cultivo
            </v-btn>
          </v-col>
        </template>
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editCultivo.nombre"
                      label="Nombre"
                      :rules="commonRules"
                      :counter="nombreLength"
                      outlined
                      autofocus
                    ></v-text-field>
                  </v-col>
                  <v-col
                    ><v-radio-group
                      v-model="editCultivo.tipo"
                      column
                      class="mt-0 pt-0"
                      mandatory
                    >
                      <v-radio
                        label="Cultura verano"
                        :value="1"
                        class="mb-2 pl-4"
                      ></v-radio>
                      <v-radio
                        label="Cultura invierno"
                        :value="2"
                        class="my-2 pl-4"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-row class="text-center">
              <v-col class="py-0">
                <v-btn color="black" text @click="close" class="">
                  Cancelar
                </v-btn>
              </v-col>
              <v-col class="py-0">
                <v-btn color="primary" text @click="save"> Guardar </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-row>
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="listaCultivos"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.tipo`]="{ item }">
            {{ item.tipo === 1 ? "Cultura verano" : "Cultura invierno" }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-5" @click="editarCultivo(item)">
              fa-pen
            </v-icon>
            <v-icon small @click="deleteCultivo(item)" color="error">
              fa-trash
            </v-icon>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 text-break"
              >¿Está seguro que quiere eliminar el cultivo
              seleccionado?</v-card-title
            >
            <v-card-text class="text-center text-h5 red--text">{{
              editCultivo.nombre
            }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="black" text @click="closeDelete">Cancelar</v-btn>
              <v-btn color="error" text @click="deleteCultivoConfirm"
                >Eliminar</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-row>
  </fh-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import FhContainer from "@/components/FhContainer";
import FhCard from "@/components/FhCard";
import ValoresRepository from "@/services/ValoresRepository";
export default {
  name: "AdminAgroCultivo",
  components: { FhCard, FhContainer },
  data() {
    return {
      // dialog flags
      dialog: false,
      dialogDelete: false,
      valid: false,
      saveDisabled: false,
      nombreLength: 30,
      commonRules: [
        (v) => !!v || "Campo obligatorio",
        (v) =>
          !v ||
          v.length <= this.nombreLength ||
          `No debe superar ${this.nombreLength} caracteres`,
      ],
      completeRules: [(v) => !!v || "Campo obligatorio"],
      editedIndex: -1,
      editCultivo: {
        idCultivo: 0,
        nombre: "",
        tipo: 0,
      },
      defaultCultivo: {
        idCultivo: 0,
        nombre: "",
        tipo: 0,
      },
      headers: [
        { text: "Nombre", value: "nombre" },
        { text: "Tipo", value: "tipo" },
        { text: "Acciones", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapState("cultivos", ["listaCultivos"]),
    formTitle() {
      return this.editedIndex === -1 ? "Nueva cultivo" : "Editar cultivo";
    },
  },
  methods: {
    ...mapActions("cultivos", ["fetchListaCultivos", "clearListaCultivos"]),
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editCultivo = Object.assign({}, this.defaultCultivo);
        this.editedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editCultivo = Object.assign({}, this.defaultCultivo);
        this.editedIndex = -1;
      });
    },
    editarCultivo(cultivo) {
      this.editedIndex = this.listaCultivos.indexOf(cultivo);
      this.editCultivo = Object.assign({}, cultivo);
      this.dialog = true;
    },
    deleteCultivo(cultivo) {
      this.editedIndex = this.listaCultivos.indexOf(cultivo);
      this.editCultivo = Object.assign({}, cultivo);
      this.dialogDelete = true;
    },
    async deleteCultivoConfirm() {
      await ValoresRepository.debajaCultivo(this.editCultivo.idCultivo);
      this.clearListaCultivos();
      await this.fetchListaCultivos();
      this.closeDelete();
    },
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.editedIndex > -1) {
            await ValoresRepository.actualizarCultivo(
              this.editCultivo.idCultivo,
              this.editCultivo.tipo,
              this.editCultivo.nombre
            );
          } else {
            await ValoresRepository.crearCultivo(
              this.editCultivo.tipo,
              this.editCultivo.nombre
            );
          }
          this.editCultivo = Object.assign({}, this.defaultCultivo);
          this.editedIndex = -1;

          this.clearListaCultivos();
          await this.fetchListaCultivos();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.close();
    },
  },
  async created() {
    await this.fetchListaCultivos();
  },
};
</script>
<style lang=""></style>
